function Required() {
    return <label className='required'>&nbsp;*</label>;
}

export default Required;
